export type StatusType =
  | 'incomplete'
  | 'recorded'
  | 'confirmed'
  | 'completed'
  | 'inprogress'
  | 'fixed'
  | 'on_route'
  | 'arrived'
  | 'complete'
  | 'cancelled'
  | 'unknown'
  | 'delivered'
  | 'open'
  | 'undefined'
  | 'invoiced'
  | 'received'
  | 'not_done'
  | 'partial';

export const STATUS_LABEL: Partial<Record<StatusType, string>> = {
  incomplete: 'Incomplete',
  recorded: 'Recorded',
  confirmed: 'Confirmed',
  completed: 'Completed',
  inprogress: 'In Progress',
  fixed: 'Fixed',
  on_route: 'On Route',
  arrived: 'Arrived',
  complete: 'Complete',
  cancelled: 'Cancelled',
  unknown: 'Unknown',
  delivered: 'Delivered',
  open: 'Open',
  undefined: 'Undefined',
  invoiced: 'Invoiced',
  received: 'Received',
  not_done: 'Not Done',
  partial: 'Partial',
};

export type StatusesType = keyof typeof STATUS_LABEL;

export const FormInterviewState = {
  EMPTY: 'empty',
  ALREADY_SUBMITTED: 'alreadySubmitted',
  ERROR: 'error',
  PENDING: 'pending',
  SUCCESS: 'success',
} as const;

export type InterviewState = (typeof FormInterviewState)[keyof typeof FormInterviewState];

export enum CaseSearchStatus {
  EXISTING = 'existing',
  NEW = 'new',
}

export class UserStatuses {
  public static readonly ACTIVE = 'ACTIVE';
  public static readonly PENDING = 'PENDING';
}

export class UserRoles {
  public static readonly ADMIN = 'ADMIN';
  public static readonly USER = 'USER';
}
